/**
 * gatsby-browser.tsx
 * Browser-side Gatsby APIs.
 * - Scroll-to-top on page navigation (skips anchor links and initial load)
 * - IntersectionObserver for scroll-triggered animations (.animate-on-scroll → .is-visible)
 */

const initScrollAnimations = () => {
  if (typeof IntersectionObserver === "undefined") return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -48px 0px" }
  );

  document.querySelectorAll(".animate-on-scroll").forEach((el) => {
    observer.observe(el);
  });
};

// Run after each route change (initial load + navigation)
export const onRouteUpdate = ({
  location,
  prevLocation,
}: {
  location: Location;
  prevLocation: Location | null;
}) => {
  // Scroll to top only on actual page transitions:
  // - skip initial page load (prevLocation is null)
  // - skip anchor navigation within the same page (#section)
  if (prevLocation && !location.hash) {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }

  // Small delay to let React render the new page DOM
  setTimeout(initScrollAnimations, 120);
};
